export default function () {
  return {
    schedules: [],
    schedule: {},
    postTemplates: [],
    postTemplate: {},
    postApproval: [],
  }
}
